// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
#date-radio {
  /* ラジオボタンを非表示にする */
  /* ラジオボタンを横並びにする */
  display: flex;
  justify-content: flex-start; /* 左寄せを設定 */
  /* カスタムラジオボタンのスタイル */
  /* ホバー時のスタイル */
  /* 選択時のスタイル */
  /* ローディング状態のスタイル */
}
#date-radio .date-radio-input {
  display: none;
  align-items: left;
}
#date-radio .date-radio-wrapper {
  display: inline-flex;
  align-items: center;
  margin-right: 4px;
}
#date-radio .date-radio-wrapper:last-child {
  margin-right: 0; /* 最後の要素の右側マージンを0にする */
}
#date-radio .date-radio-label {
  min-width: 96px; /* ラベルの幅を固定 */
  height: 28px; /* ラベルの高さを固定 */
  margin: 0px 0px 0px 0px;
  border: 1px solid var(--border-weak-color);
  border-radius: 24px;
  background-color: var(-white-color-lightest);
  transition: background-color 0.3s, color 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--text-size-small);
  white-space: nowrap;
  padding: 0 12px;
}
#date-radio .date-radio-label:hover {
  background-color: var(--dark-color-main);
  color: var(--white-color-main);
  cursor: pointer;
}
#date-radio .date-radio-input:checked + .date-radio-label {
  background-color: var(--dark-color-dark);
  color: var(--white-color-lightest);
}
#date-radio .label-icon {
  margin-right: 4px; /* 最後の要素の右側マージンを0にする */
}`, "",{"version":3,"sources":["webpack://./src/components/common/parts/DateRadio.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,kBAAA;EAMA,kBAAA;EACA,aAAA;EACA,2BAAA,EAAA,WAAA;EAEA,oBAAA;EA2BA,cAAA;EAOA,aAAA;EAUA,kBAAA;AA7CF;AARE;EACI,aAAA;EACA,iBAAA;AAUN;AAFE;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;AAIJ;AADE;EACE,eAAA,EAAA,sBAAA;AAGJ;AAAE;EACE,eAAA,EAAA,aAAA;EACA,YAAA,EAAA,cAAA;EACA,uBAAA;EACA,0CAAA;EACA,mBAAA;EACA,4CAAA;EACA,6CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;EACA,mBAAA;EACA,eAAA;AAEJ;AAEE;EACE,wCAAA;EACA,8BAAA;EACA,eAAA;AAAJ;AAIE;EACE,wCAAA;EACA,kCAAA;AAFJ;AAKE;EACE,iBAAA,EAAA,sBAAA;AAHJ","sourcesContent":["#date-radio{\r\n  /* ラジオボタンを非表示にする */\r\n  .date-radio-input {\r\n      display: none;\r\n      align-items: left;\r\n  }\r\n\r\n  /* ラジオボタンを横並びにする */\r\n  display: flex;\r\n  justify-content: flex-start; /* 左寄せを設定 */\r\n  \r\n  /* カスタムラジオボタンのスタイル */\r\n  .date-radio-wrapper {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    margin-right: 4px; \r\n  }\r\n\r\n  .date-radio-wrapper:last-child {\r\n    margin-right: 0; /* 最後の要素の右側マージンを0にする */\r\n  }\r\n  \r\n  .date-radio-label {\r\n    min-width: 96px; /* ラベルの幅を固定 */\r\n    height: 28px; /* ラベルの高さを固定 */\r\n    margin: 0px 0px 0px 0px;\r\n    border: 1px solid var(--border-weak-color);\r\n    border-radius: 24px;\r\n    background-color:var(-white-color-lightest);\r\n    transition: background-color 0.3s, color 0.3s;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: var(--text-size-small);\r\n    white-space: nowrap;\r\n    padding: 0 12px;\r\n  }\r\n\r\n  /* ホバー時のスタイル */\r\n  .date-radio-label:hover {\r\n    background-color: var(--dark-color-main);\r\n    color: var(--white-color-main);\r\n    cursor: pointer;\r\n  }\r\n\r\n  /* 選択時のスタイル */\r\n  .date-radio-input:checked + .date-radio-label{\r\n    background-color: var(--dark-color-dark);\r\n    color: var(--white-color-lightest);\r\n  }\r\n\r\n  .label-icon {\r\n    margin-right: 4px; /* 最後の要素の右側マージンを0にする */\r\n  }\r\n  \r\n  /* ローディング状態のスタイル */\r\n  .loading {\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
